import React from 'react';
import DocumentTitle from 'react-document-title';
import { DefaultButton } from '@fluentui/react';
import { useHistory } from 'react-router';

const PaymentAccountError = () =>
{
	const history = useHistory();

	return (
		<DocumentTitle title='IronIA - Titularidad de Cuenta bancaria'>
			<React.Fragment>
				<div className="ms-Grid-row p10">
					<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
						<div className="section-row">
							<br />
							<div className="warning-container">
								<div>
									<img
										src="/icons/information.svg"
										alt="Información"
									/>
								</div>
								<p><i> Atención.</i></p>
								<p>
									<i>
										El titular de la cuenta desde la que se ha realizado el pago no corresponde con ningún titular del contrato. Se ha procedido a la cancelación de la orden.
									</i>
								</p>
								<p>
									<i>Porfavor, pongase en contacto con <a href="mailto:info@ironia.tech">info@ironia.tech</a></i>
								</p>
							</div>
							<div className="ms-Grid-col ms-sm12 text-right" style={{ marginTop: "20px" }}>
								<DefaultButton onClick={() => history.push("/portfolio/orders")} className="button mini-primary-button">
									Aceptar
								</DefaultButton>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		</DocumentTitle>
	);
};

export default PaymentAccountError;